import React, { useEffect, useState } from "react";
import AdminHeading from "../Heading/AdminHeading";
import AdminBreadCrump from "../Heading/AdminBreadCrump";
import "../../PagesStyles/AdminMasters.css";
import { TbCircleNumber1 } from "react-icons/tb";
import { a18, a35, a7 } from "../../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";

export default function AdminAddCategory() {
  const [active, setActive] = useState("List");
  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    name: "",
    slug: "",
    label: "",
    material: "",
    parentsCategory: "",
    description: "",
    entryByStaffId: "",
  });
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  let Entryby_Staff_id = parseInt(adminLoggedIn);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    try {
      const response = await fetch(a18);
      const data = await response.json();
      setAllCategories(data.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategory();
  }, []);
  console.log(allCategories);
  const [editingId, setEditingId] = useState(null);
  const [editedData, setEditedData] = useState({});

  const handleEditClick = (id) => {
    setEditingId(id);
    // Find the item with the selected ID and set its data in the state
    const selectedItem = allCategories.find((x) => x.id === id);
    setEditedData(selectedItem);
  };

  const handleSaveClick = () => {
    handleSubmit();
    // Save the edited data to your state or send it to an API
    console.log("Edited Data:", editedData);
    setEditingId(null); // Exit editing mode
  };
  const handleSubmit = async () => {
    try {
      const response = await fetch(a35, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editedData),
      });
      const data = await response.json();

      console.log(data, "updated");
      fetchAllCategory();
    } catch (error) {
      console.error(error);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setEditedData({ ...editedData, [name]: value });
  };

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewCategory({ ...newCategory, [name]: value });
  };
  const addNewCategory = async (e) => {
    e.preventDefault();
    const formData = {
      Name: newCategory.name,
      ParentsCategory: newCategory.parentsCategory,
      Material: newCategory.name,
      Description: newCategory.description,
      Slug: newCategory.slug,
      Label: newCategory.label,
      Entryby_Staff_id: Entryby_Staff_id,
    };
    try {
      const response = await fetch(a7, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      fetchAllCategory();
      setActive("List");
      setNewCategory({
        name: "",
        slug: "",
        label: "",
        parentsCategory: "",
        description: "",
      });
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div>
      <AdminHeading />
      <div className="adminMainBodyBox">
        <AdminBreadCrump
          title={"Add Category"}
          companyName={"Loyalstring"}
          module={"Masters"}
          page={"Category"}
        />
        <div className="adminAddCategoryMainBox">
          <div className="adminAddCategoryInnerBox">
            <div className="adminAddCategoryInnerBoxTitlesBox">
              <div
                onClick={() => {
                  setActive("List");
                }}
                className={
                  active === "List"
                    ? "adminAddCategoryInnerBoxTitle"
                    : "adminAddCategoryInnerBoxTitle activeCategoryTitle"
                }
              >
                <div
                  className={
                    active === "List"
                      ? "adminAddCategoryInnerBoxTitleLogo"
                      : "adminAddCategoryInnerBoxTitleLogo activeCategoryLogo"
                  }
                >
                  {/* 01 */}
                  <RiListUnordered />
                </div>
                <p>All Categories</p>
              </div>

              <div
                onClick={() => setActive("AddNew")}
                className={
                  active === "AddNew"
                    ? "adminAddCategoryInnerBoxTitle"
                    : "adminAddCategoryInnerBoxTitle activeCategoryTitle"
                }
              >
                <div
                  className={
                    active === "AddNew"
                      ? "adminAddCategoryInnerBoxTitleLogo"
                      : "adminAddCategoryInnerBoxTitleLogo activeCategoryLogo"
                  }
                >
                  {/* 02 */}
                  <RiPlayListAddLine />
                </div>
                <p>Add Category</p>
              </div>
            </div>
            <div
              className={
                active === "List" ? "adminCategoryListMainBox" : "none"
              }
            >
              <table>
                <thead>
                  <tr>
                    <th>Edit</th>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Slug</th>
                    <th>Label</th>
                    <th>Parent Category</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {allCategories.map((x) => (
                    <tr key={x.id}>
                      <td>
                        {editingId === x.id ? (
                          <button
                            className="adminAddCategorySaveButton"
                            onClick={handleSaveClick}
                          >
                            Save
                          </button>
                        ) : (
                          <button
                            className="adminAddCategoryEditButton"
                            onClick={() => handleEditClick(x.id)}
                          >
                            Edit
                          </button>
                        )}
                      </td>
                      <td>{x.id}</td>
                      <td>
                        {editingId === x.id ? (
                          <input
                            type="text"
                            name="name"
                            value={editedData.name || ""}
                            onChange={handleInputChange}
                          />
                        ) : (
                          x.name
                        )}
                      </td>
                      <td>
                        {editingId === x.id ? (
                          <input
                            type="text"
                            name="slug"
                            value={editedData.slug || ""}
                            onChange={handleInputChange}
                          />
                        ) : (
                          x.slug
                        )}
                      </td>
                      <td>
                        {editingId === x.id ? (
                          <input
                            type="text"
                            name="label"
                            value={(editedData.label || "").toUpperCase()} // Convert to uppercase
                            onChange={handleInputChange}
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(
                                /[^A-Z0-9 ]/g,
                                ""
                              ); // Allow only uppercase letters, numbers, and spaces
                              handleInputChange(e);
                            }}
                          />
                        ) : (
                          x.label
                        )}
                      </td>

                      <td>
                        {editingId === x.id ? (
                          <select
                            name="parentsCategory"
                            value={editedData.parentsCategory || ""}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select an option</option>
                            <option value="Metal">Metal</option>
                            <option value="Non-Metal">Non-Metal</option>
                          </select>
                        ) : (
                          x.parentsCategory
                        )}
                      </td>
                      <td>
                        {editingId === x.id ? (
                          <input
                            type="text"
                            name="description"
                            value={editedData.description || ""}
                            onChange={handleInputChange}
                          />
                        ) : (
                          x.description
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div
              className={
                active !== "List" ? "adminCategoryAddCategoryMainBox" : "none"
              }
            >
              <p>Add New Category</p>
              <form onSubmit={addNewCategory}>
                <div className="adminCategoryAddCategoryInnerBox">
                  <label>Name</label>
                  <input
                    name="name"
                    value={newCategory.name}
                    onChange={handleNewCategoryChange}
                    type="text"
                    required="required"
                  />
                  <label>Slug</label>
                  <input
                    name="slug"
                    value={newCategory.slug}
                    onChange={handleNewCategoryChange}
                    type="text"
                  />
                  <label>Label</label>
                  <input
                    name="label"
                    value={newCategory.label}
                    onChange={handleNewCategoryChange}
                    type="text"
                    required="required"
                    placeholder="Only Capitals"
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(
                        /[^A-Z0-9 ]/g,
                        ""
                      );
                    }}
                  />
                  <label>Parent Category</label>
                  <select
                    name="parentsCategory"
                    required="required"
                    value={newCategory.parentsCategory}
                    onChange={handleNewCategoryChange}
                    type="text"
                  >
                    <option value="">Select an option</option>
                    <option value="Metal">Metal</option>
                    <option value="Non-Metal">Non-Metal</option>
                  </select>
                  <label>Description</label>
                  <input
                    name="description"
                    value={newCategory.description}
                    onChange={handleNewCategoryChange}
                    type="text"
                  />
                  <button type="submit">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
